// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","tileContainer":"galleryTile_tileContainer__2jD-J"};